module.exports = __webpack_public_path__ + "img/logo.bd799fca.png";